import { Alert, Box, Grid2, Typography } from "@mui/material";
import { FormEvent, useState } from "react";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useNavigate } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { BrandEnum } from "../../_common/enum/brand.enum";
import { StandardButton } from "../../_components/button/primary.button";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { accountService } from "../../_services/accounts.service";
import { authScreenStyles } from "../../_styles/authScreen.styles";
import { AuthLogo } from "./_components/authLogo";


export function LoginVerifyCode(params: { brand: BrandEnum }) {

    let navigate = useNavigate();
    let { pathname } = useLocation();

    let username = "";
    if (pathname && pathname.indexOf("username=") !== -1) {
        const raw = pathname.split("username=")[1] ?? "";
        try {
            username = decodeURIComponent(raw);
        } catch {
            username = raw;
        }
    }

    const [isLoading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [warning, setWarning] = useState("");
    const [isLockedOut, setIsLockedOut] = useState(false);

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.verifyCode(username, code)
            .then(
                (item => {
                    navigate("/");
                }),
                ((err) => {
                    setIsLockedOut(true);
                    setWarning(err);
                }))
            .finally(() => {
                setLoading(false);
            });
    }


    return (
        <>
            <AuthLogo brand={params.brand} />

            <Typography sx={authScreenStyles.subheading}>
                Multi-factor authentication is required to login to this account
            </Typography>

            <Alert severity="warning" sx={authScreenStyles.alert}>
                A verification code has been sent to your email. Please enter it below.
            </Alert>

            {isLockedOut && (
                <Alert severity="error" sx={authScreenStyles.alert}>
                    {warning}
                </Alert>
            )}

            <ValidatorForm onSubmit={submit} noValidate style={authScreenStyles.form}>
                <Grid2 container spacing={2} sx={authScreenStyles.formContainer}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            required
                            fullWidth
                            label="Verification Code"
                            name="code"
                            value={code}
                            disabled={isLoading}
                            onChange={(e: any) => setCode(e.target.value.toString())}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                            autoFocus
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            type="submit"
                            variant="primary"
                            loading={isLoading}
                            icon={"check"}>
                            Submit
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>

            <Box sx={authScreenStyles.linkContainer}>
                <Link style={authScreenStyles.link} to="/login">
                    Back to Log In screen
                </Link>
            </Box>
        </>
    );
}